import { Paper } from "@mui/material";
import { Collections, ConfirmationNumber, Savings, Storage } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useAccount } from "wagmi";

import { BusinessType, ChainLinkV2SupportedChains } from "@framework/types";
import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.lottery.contracts.title", link: "/lottery/contracts", icon: <Collections /> },
  { text: "pages.lottery.rounds.title", link: "/lottery/rounds", icon: <Savings /> },
  { text: "pages.lottery.tickets.title", link: "/lottery/ticket/contracts", icon: <ConfirmationNumber /> },
  { text: "pages.lottery.tokens.title", link: "/lottery/ticket/tokens", icon: <Storage /> },
];

export const LotterySection = () => {
  const { chainId = 0 } = useAccount();

  if (process.env.BUSINESS_TYPE === BusinessType.B2B) {
    return null;
  }

  if (process.env.NODE_ENV === NodeEnv.production && !ChainLinkV2SupportedChains[chainId]) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.lottery" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
